import { type } from "../types/types";

export const set_disputes = (disputes) => (dispatch) => {
  dispatch({
    type: type.SET_DISPUTES,
    disputes: disputes,
  });
};

export const set_dispute_detail = (disputeDetail) => (dispatch) => {
  dispatch({
    type: type.SET_DISPUTE_DETAIL,
    disputeDetail: disputeDetail,
  });
};
